import { render } from "./RoleDetails.vue?vue&type=template&id=f8ff8a68&ts=true"
import script from "./RoleDetails.vue?vue&type=script&lang=ts"
export * from "./RoleDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__